export const translations = {
  it: {
    nav: { apps: "Le App", manifesto: "Manifesto", beyond: "Oltre", contact: "Contatti" },
    hero: {
      kicker: "Roma, Italia",
      name: "FABIO COMELLI",
      role: "Software Developer",
      motto: "Parole · Numeri · Magia",
      sub: "Mi informo, creo e condivido. Che siano giochi di parole o matematici, tecniche di lettura rapida o di apprendimento, qui potete trovare le mie app oltre i collegamenti alle Live su Twitch, al Blog, alla Musica creata con Suno e agli effetti di Magia.",
      ctaApps: "Scopri le app",
      ctaContact: "Scrivimi",
      scroll: "Scorri",
    },
    marquee: ["PAROLE IN CODA · APP STORE E GOOGLE PLAY", "CIFROO · APP STORE E GOOGLE PLAY", "CTHULHU TRACKER · APP STORE E GOOGLE PLAY", "SIMPLE AND FAST · IN ARRIVO", "LAMPO READER · SU APP STORE", "LAMPO MEMORY · IN ARRIVO", "DPT · SU APP STORE", "LAMPO MAGIC · IN ARRIVO", "CAT REVERSI · IN ARRIVO", "SLIDE & SOLVE · IN ARRIVO", "LAMPO STORE SERVER · IN ARRIVO", "LAMPO STORE · IN ARRIVO"],
    showcase: {
      kicker: "Le App",
      title: "Le mie applicazioni, divertenti e utili, create per voi",
      sub: "Ogni app ha la sua pagina: descrizione completa, screenshot, novità dell'ultimo aggiornamento e un'eventuale anteprima di cosa bolle in pentola.",
      open: "Apri la scheda",
      comingSoon: "In arrivo",
      store: "Scarica su App Store",
      soonStore: "Presto su App Store",
      play: "Presto su Google Play",
    },
    magic: {
      kicker: "Oltre le app",
      title: "Parole in Treno",
      badge: "Effetto di mentalismo",
      desc: "Prima delle app c'era la magia: Parole in Treno è il mio effetto di mentalismo pubblicato da Hyde. Una parola scelta liberamente dallo spettatore viene indovinata senza errori — impromptu, senza gimmick, ripetibile all'infinito e con carte controllabili fino all'ultimo.",
      includes: ["Spiegazione dettagliata con dettagli fondamentali", "PDF per realizzare le carte e i fogli con le parole", "Opzione mazzo bianco per eseguirlo più comodamente"],
      cta: "Acquista su Hyde Store",
      lampoLink: "In arrivo anche in Lampo Magic",
      video: "Il video di lancio",
    },
    twitch: {
      kicker: "Twitch — DottorFabio",
      offline: "Al momento non sono in live",
      live: "In diretta ora",
      watch: "Guarda la live",
      follow: "Segui il canale",
      viewers: "spettatori",
    },
    manifesto: {
      kicker: "Manifesto",
      title: "Come sviluppo",
      chapters: [
        { n: "01", t: "Niente attrito", d: "Le mie app si aprono e funzionano. Niente registrazioni obbligatorie quando non servono, niente muri: apri, giochi, chiudi." },
        { n: "02", t: "Artigianato digitale", d: "Ogni schermata è curata in ogni dettaglio e ogni aggiornamento aggiunge qualcosa che migliora l'esperienza. Ascolto chi gioca e miglioro in continuazione." },
        { n: "03", t: "Meglio in compagnia", d: "Passa il telefono, duelli online, sessioni sincronizzate in tempo reale: le mie app nascono per far giocare le persone insieme." },
      ],
    },
    app: {
      whatsNew: "Novità",
      lastUpdate: "Ultimo aggiornamento",
      roadmap: "In sviluppo",
      roadmapSub: "Un'anteprima di cosa arriverà nei prossimi aggiornamenti.",
      gallery: "Screenshot",
      about: "L'app",
      version: "Versione",
      category: "Categoria",
      size: "Dimensioni",
      age: "Età",
      back: "Tutte le app",
      privacy: "Privacy Policy",
      soonBadge: "In sviluppo attivo",
      family: "La famiglia Lampo",
      familySub: "App che si potenziano a vicenda: scopri come lavorano insieme.",
      soonNote: "Simple and Fast è in fase di sviluppo e arriverà presto su App Store e Google Play.",
    },
    tester: {
      cta: "Partecipa al test per usarla in anteprima",
      ctaNote: "clicca per saperne di più",
      title: "Diventa tester Android",
      intro: "Vuoi provare {app} su Android prima dell'uscita? Lasciami i tuoi contatti: ti aggiungerò al gruppo di tester su Google Play e riceverai l'invito appena la versione di prova sarà disponibile.",
      warn: "Importante: indica l'indirizzo email che usi sul Google Play Store — è quello che Google usa per abilitarti al download.",
      name: "Il tuo nome",
      email: "Email che usi su Google Play",
      message: "Messaggio (facoltativo)",
      send: "Invia la richiesta",
      sending: "Invio…",
      ok: "Richiesta inviata! Ti scriverò appena il test è aperto.",
      ko: "Errore di invio. Riprova o scrivi a info@fabiocomelli.it",
      close: "Chiudi",
    },
    demo: {
      kicker: "Mini demo",
      title: "La Sfida del Giorno",
      sub: "Un puzzle nuovo ogni giorno, uguale per tutti: tocca una tessera, poi un'operazione, poi un'altra tessera. Vinci appena raggiungi il numero bersaglio. Hai un solo aiuto.",
      target: "Bersaglio",
      undo: "Annulla",
      restart: "Ricomincia",
      hint: "Aiuto",
      hintPrefix: "Prova",
      confirm: "Conferma",
      readyText: "Bersaglio raggiunto!",
      share: "Condividi",
      copied: "Copiato!",
      start: "Inizia la sfida",
      streakLabel: "Serie",
      dayOne: "giorno",
      dayMany: "giorni",
      solvedIn: "Risolto in",
      lostTitle: "Nessuna via d'uscita",
      lostSub: "Con queste tessere il bersaglio non è più raggiungibile. Annulla l'ultima mossa o riprova da capo.",
      retry: "Riprova",
      dailyWin: "Sfida del Giorno completata!",
      dailyWinSub: "Torna domani per una sfida nuova.",
      divError: "Divisione non esatta: riprova",
    },
    contact: {
      kicker: "Contatti",
      title: "Parliamone.",
      sub: "Feedback, segnalazioni di bug, idee o collaborazioni: scrivimi e ti risponderò al più presto.",
      name: "Il tuo nome",
      email: "La tua email",
      message: "Il tuo messaggio",
      send: "Invia il messaggio",
      sending: "Invio in corso…",
      privacyNotePre: "Inviando accetti la ",
      privacyNoteLink: "privacy policy del sito",
      privacyNotePost: ": i tuoi dati servono solo a risponderti.",
      ok: "Messaggio inviato. Grazie, ti risponderò presto!",
      ko: "Invio non riuscito. Riprova o scrivimi a info@fabiocomelli.it",
    },
    support: {
      kicker: "Assistenza",
      title: "Supporto app",
      sub: "Hai un problema, una domanda o un suggerimento su una delle mie app? Sono qui per aiutarti.",
      emailLabel: "Email di supporto",
      response: "Rispondo di solito entro 24–48 ore lavorative.",
      extra: "Come funziona l'assistenza: ogni messaggio arriva direttamente a me, non a un sistema automatico. Leggo tutto personalmente — segnalazioni di bug, richieste di nuove funzionalità, problemi con gli acquisti in-app o con il ripristino, dubbi sulle regole dei giochi. Se scrivi per un problema tecnico, più dettagli mi dai (dispositivo, versione di iOS, passaggi per riprodurlo) prima riesco a risolverlo. Per i bug critici che bloccano il gioco pubblico di solito un aggiornamento correttivo entro pochi giorni.",
      howTitle: "Cosa includere nella segnalazione",
      howItems: ["Il nome dell'app e la sua versione", "Il dispositivo e la versione di iOS", "Una descrizione del problema o della richiesta", "Uno screenshot, se utile"],
      contactCta: "Scrivimi dal form contatti",
      appsTitle: "Le app",
      storeNote: "Disponibile su App Store",
      soonNote: "In arrivo su App Store",
      commonTitle: "Problemi comuni e soluzioni rapide",
      commonItems: [
        { t: "Gli acquisti in-app non si attivano", d: "Se hai acquistato \"Rimuovi pubblicità\" o il pacchetto Master ma non risulta attivo, apri le impostazioni dell'app e tocca \"Ripristina acquisti\" usando lo stesso account Apple o Google dell'acquisto. Se il problema resta, scrivimi indicando la data dell'acquisto: lo verifico e lo risolvo personalmente." },
        { t: "L'app è lenta o si chiude all'avvio", d: "Chiudi le app in background e riavvia il dispositivo: risolve la maggior parte dei casi. Verifica anche di avere l'ultima versione dall'App Store o da Google Play. Se il crash continua, segnalamelo indicando dispositivo e versione del sistema operativo." },
        { t: "Parole mancanti in Parole in Coda", d: "Se una parola valida non viene accettata, usa il pulsante \"Segnala\" direttamente in partita, oppure scrivimi dal form contatti. Le segnalazioni vengono raccolte e il dizionario viene aggiornato con regolarità." },
        { t: "Sincronizzazione live di Cthulhu Tracker", d: "Per la sincronizzazione in tempo reale, Custode e Giocatori devono essere online e collegati alla stessa sessione. Se i dati non si aggiornano, esci e rientra nella sessione; se persiste, controlla la connessione e riavvia l'app." },
      ],
    },
    blogPrev: {
      kicker: "Il blog",
      title: "Le urla e il silenzio",
      more: "Tutti gli articoli",
    },
    beyond: {
      kicker: "Oltre lo sviluppo",
      title: "Oltre il codice",
      sub: "Sviluppare app è solo una parte: scrivo poesie e prose, smonto bufale, faccio magia e insegno tecniche di apprendimento. Il resto lo trovi sul mio blog, La Sveglia e il Risveglio.",
      articlesTitle: "Articoli scelti dal blog",
      history: "Il blog è nato prima delle app: dal 2017 pubblico poesie, haiku, prose e divulgazione scientifica. La Sveglia e il Risveglio è il mio spazio personale — le urla quando qualcosa mi fa arrabbiare, il silenzio quando scrivo in versi. Gli articoli qui sotto sono solo una selezione: sul blog trovi tutto l'archivio, dai debunking sul 5G e sui complotti ai pezzi più intimi sull'amicizia e sui percorsi di vita.",
      readArticle: "Leggi l'articolo",
      blogCta: "Visita il blog",
    },
    faq: {
      title: "Domande frequenti",
      items: [
        { q: "Come vi contatto per un problema?", a: "Scrivimi a info@fabiocomelli.it o usa il form contatti: indicami il nome dell'app, la versione, il dispositivo e una descrizione del problema. Rispondo di solito entro 24–48 ore lavorative." },
        { q: "Parole in Coda: come rimuovo la pubblicità?", a: "Dalle impostazioni dell'app puoi acquistare “Rimuovi pubblicità” con un unico acquisto. Se cambi dispositivo o reinstalli l'app, usa “Ripristina acquisti” per recuperarlo senza pagare di nuovo." },
        { q: "Parole in Coda: dove sono salvati i miei record?", a: "Statistiche, record e preferenze sono salvati solo sul tuo dispositivo: se disinstalli l'app o cancelli i suoi dati, vengono eliminati definitivamente." },
        { q: "Cthulhu Tracker: come gioco con il mio gruppo?", a: "Il Custode crea una sessione e i giocatori si uniscono con le proprie schede: ogni modifica è sincronizzata in tempo reale. Per la sincronizzazione serve un account, con accesso tramite Apple o Google." },
        { q: "Le app sono gratuite?", a: "Cthulhu Tracker, Cifroo e Lampo Reader sono completamente gratuite — Lampo Reader anche senza pubblicità. Parole in Coda è gratuita con un acquisto opzionale per rimuovere la pubblicità. Simple and Fast sarà gratuita per i giocatori: i Master sbloccano regolamento completo, scenari e strumenti di gestione con un unico acquisto da 9,99 €." },
        { q: "Quando arrivano Simple and Fast e le versioni Android?", a: "Parole in Coda, Cifroo e Cthulhu Tracker sono già disponibili su Google Play, e Lampo Reader è arrivato su App Store (per iPhone e iPad, con Mac e Android in arrivo)! Simple and Fast uscirà prima su App Store e poi su Google Play." },
      ],
    },
    music: {
      kicker: "Musica",
      title: "La mia musica",
      desc: "24 brani che ho creato con Suno: dalle musiche di sottofondo di Parole in Coda e Cifroo, pensate per concentrarsi, alle atmosfere lovecraftiane perfette per le sessioni di Cthulhu Tracker.",
      songs: "24 brani · Playlist di DottorFabio",
      nowPlaying: "In riproduzione",
      morePre: "E altri brani basati su articoli e poesie tratti dal mio ",
      moreLink: "blog",
      morePost: ".",
      cta: "Ascolta su Suno",
    },
    youtube: {
      kicker: "YouTube",
      title: "Ultimi video",
      more: "Vai al canale",
    },
    social: {
      kicker: "Social",
      title: "Seguimi in giro",
      twitch: "Segui su Twitch",
      youtube: "Iscriviti su YouTube",
      instagram: "Segui su Instagram",
    },
    footer: {
      apps: "Le app",
      legal: "Legale",
      contact: "Contatto",
      donate: "Dona con PayPal",
      rights: "© 2026 Fabio Comelli — Tutti i diritti riservati",
    },
    privacy: {
      updated: "Ultimo aggiornamento",
      back: "Torna alla home",
      forApp: "Informativa sulla privacy di",
      switchNote: "Read in English",
      indexTitle: "Privacy Policy",
      indexH1: "Privacy delle app e del sito",
      indexSub: "Tutte le informative privacy delle app e del sito, raccolte in un'unica pagina.",
    },
  },
  en: {
    nav: { apps: "Apps", manifesto: "Manifesto", beyond: "Beyond", contact: "Contact" },
    hero: {
      kicker: "Rome, Italy",
      name: "FABIO COMELLI",
      role: "Software Developer",
      motto: "Words · Numbers · Magic",
      sub: "I learn, create and share. Whether it's word games or number puzzles, speed-reading or learning techniques, here you'll find my apps plus links to my Twitch live streams, the Blog, Music made with Suno and Magic effects.",
      ctaApps: "Explore the apps",
      ctaContact: "Get in touch",
      scroll: "Scroll",
    },
    marquee: ["PAROLE IN CODA · APP STORE & GOOGLE PLAY", "CIFROO · APP STORE & GOOGLE PLAY", "CTHULHU TRACKER · APP STORE & GOOGLE PLAY", "SIMPLE AND FAST · COMING SOON", "LAMPO READER · ON THE APP STORE", "LAMPO MEMORY · COMING SOON", "DPT · ON THE APP STORE", "LAMPO MAGIC · COMING SOON", "CAT REVERSI · COMING SOON", "SLIDE & SOLVE · COMING SOON", "LAMPO STORE SERVER · COMING SOON", "LAMPO STORE · COMING SOON"],
    showcase: {
      kicker: "The Apps",
      title: "My apps, fun and useful, created for you",
      sub: "Each app has its own page: full description, screenshots, what's new in the latest update and, possibly, a preview of what's cooking.",
      open: "Open app page",
      comingSoon: "Coming soon",
      store: "Download on the App Store",
      soonStore: "Soon on the App Store",
      play: "Soon on Google Play",
    },
    magic: {
      kicker: "Beyond apps",
      title: "Parole in Treno",
      badge: "Mentalism effect",
      desc: "Before apps there was magic: Parole in Treno is my mentalism effect published by Hyde. A word freely chosen by the spectator is revealed with no errors — impromptu, no gimmicks, endlessly repeatable, with cards the spectator can fully examine.",
      includes: ["Detailed explanation with key subtleties", "PDFs to make the cards and word sheets", "Optional blank deck for an even easier setup"],
      cta: "Buy on Hyde Store",
      lampoLink: "Coming soon inside Lampo Magic",
      video: "Watch the launch video",
    },
    twitch: {
      kicker: "Twitch — DottorFabio",
      offline: "Not live right now",
      live: "Live now",
      watch: "Watch the stream",
      follow: "Follow the channel",
      viewers: "viewers",
    },
    manifesto: {
      kicker: "Manifesto",
      title: "How I develop",
      chapters: [
        { n: "01", t: "Zero friction", d: "My apps open and just work. No forced sign-ups when they're not needed, no walls: open, play, close." },
        { n: "02", t: "Digital craftsmanship", d: "Every screen is crafted in every detail and every update adds something that improves the experience. I listen to players and improve constantly." },
        { n: "03", t: "Better together", d: "Pass-the-phone, online duels, real-time synced sessions: my apps are made to get people playing together." },
      ],
    },
    app: {
      whatsNew: "What's new",
      lastUpdate: "Latest update",
      roadmap: "In development",
      roadmapSub: "A preview of what's coming in the next updates.",
      gallery: "Screenshots",
      about: "The app",
      version: "Version",
      category: "Category",
      size: "Size",
      age: "Age",
      back: "All apps",
      privacy: "Privacy Policy",
      soonBadge: "In active development",
      family: "The Lampo family",
      familySub: "Apps that make each other stronger: discover how they work together.",
      soonNote: "Simple and Fast is currently in development and will land soon on the App Store and Google Play.",
    },
    tester: {
      cta: "Join the test to use it early",
      ctaNote: "click to learn more",
      title: "Become an Android tester",
      intro: "Want to try {app} on Android before launch? Leave me your contacts: I'll add you to the tester group on Google Play and you'll get the invite as soon as the test build is available.",
      warn: "Important: use the email address linked to your Google Play Store account — that's what Google uses to grant you the download.",
      name: "Your name",
      email: "The email you use on Google Play",
      message: "Message (optional)",
      send: "Send request",
      sending: "Sending…",
      ok: "Request sent! I'll write to you as soon as the test opens.",
      ko: "Sending failed. Try again or write to info@fabiocomelli.it",
      close: "Close",
    },
    demo: {
      kicker: "Mini demo",
      title: "The Daily Challenge",
      sub: "A new puzzle every day, the same for everyone: tap a tile, then an operation, then another tile. You win as soon as you reach the target number. You only get one hint.",
      target: "Target",
      undo: "Undo",
      restart: "Restart",
      hint: "Hint",
      hintPrefix: "Try",
      confirm: "Confirm",
      readyText: "Target reached!",
      share: "Share",
      copied: "Copied!",
      start: "Start the challenge",
      streakLabel: "Streak",
      dayOne: "day",
      dayMany: "days",
      solvedIn: "Solved in",
      lostTitle: "No way out",
      lostSub: "With these tiles the target is no longer reachable. Undo your last move or start over.",
      retry: "Try again",
      dailyWin: "Daily Challenge completed!",
      dailyWinSub: "Come back tomorrow for a new challenge.",
      divError: "Not an exact division: try again",
    },
    contact: {
      kicker: "Contact",
      title: "Let's talk.",
      sub: "Feedback, bug reports, ideas or collaborations: drop me a line and I'll get back to you soon.",
      name: "Your name",
      email: "Your email",
      message: "Your message",
      send: "Send message",
      sending: "Sending…",
      privacyNotePre: "By sending you accept the ",
      privacyNoteLink: "site privacy policy",
      privacyNotePost: ": your data is only used to reply to you.",
      ok: "Message sent. Thanks, I'll reply soon!",
      ko: "Something went wrong. Try again or write to info@fabiocomelli.it",
    },
    support: {
      kicker: "Support",
      title: "App support",
      sub: "Having an issue, a question or a suggestion about one of my apps? I'm here to help.",
      emailLabel: "Support email",
      response: "I usually reply within 24–48 working hours.",
      extra: "How support works: every message reaches me directly, not an automated system. I read everything personally — bug reports, feature requests, issues with in-app purchases or restores, questions about game rules. If you're writing about a technical problem, the more detail you give me (device, iOS version, steps to reproduce it) the faster I can fix it. For critical bugs that block gameplay I usually ship a fix update within a few days.",
      howTitle: "What to include in your report",
      howItems: ["The app name and its version", "Your device and iOS version", "A description of the issue or request", "A screenshot, if helpful"],
      contactCta: "Write via the contact form",
      appsTitle: "The apps",
      storeNote: "Available on the App Store",
      soonNote: "Coming soon to the App Store",
      commonTitle: "Common issues and quick fixes",
      commonItems: [
        { t: "In-app purchases not activating", d: "If you bought \"Remove ads\" or the Master pack but it doesn't show as active, open the app settings and tap \"Restore purchases\" with the same Apple or Google account used for the purchase. If the issue persists, write to me with the purchase date: I'll check it and fix it personally." },
        { t: "The app is slow or crashes on launch", d: "Close background apps and restart your device: this fixes most cases. Also make sure you have the latest version from the App Store or Google Play. If the crash continues, report it with your device model and OS version." },
        { t: "Missing words in Parole in Coda", d: "If a valid word is not accepted, use the \"Report\" button right in the game, or write to me via the contact form. Reports are collected and the dictionary is updated regularly." },
        { t: "Cthulhu Tracker live sync", d: "For real-time sync, the Keeper and Players must be online and joined to the same session. If data doesn't update, leave and rejoin the session; if it persists, check your connection and restart the app." },
      ],
    },
    faq: {
      title: "Frequently asked questions",
      items: [
        { q: "How do I contact you about a problem?", a: "Email me at info@fabiocomelli.it or use the contact form: include the app name, its version, your device and a description of the issue. I usually reply within 24–48 working hours." },
        { q: "Parole in Coda: how do I remove ads?", a: "From the app settings you can buy “Remove ads” with a single purchase. If you change device or reinstall the app, use “Restore purchases” to get it back at no cost." },
        { q: "Parole in Coda: where are my records saved?", a: "Stats, records and preferences are stored only on your device: if you uninstall the app or clear its data, they are permanently deleted." },
        { q: "Cthulhu Tracker: how do I play with my group?", a: "The Keeper creates a session and players join with their own sheets: every change syncs in real time. Syncing requires an account, with Apple or Google sign-in." },
        { q: "Are the apps free?", a: "Cthulhu Tracker, Cifroo and Lampo Reader are completely free — Lampo Reader with no ads at all. Parole in Coda is free with an optional purchase to remove ads. Simple and Fast will be free for players: Masters unlock the full ruleset, scenarios and management tools with a single €9.99 purchase." },
        { q: "When will Simple and Fast and the Android versions arrive?", a: "Parole in Coda, Cifroo and Cthulhu Tracker are already available on Google Play, and Lampo Reader just landed on the App Store (for iPhone and iPad, with Mac and Android coming soon)! Simple and Fast launches first on the App Store, then on Google Play." },
      ],
    },
    blogPrev: {
      kicker: "The blog",
      title: "The shouts and the silence",
      more: "All articles",
    },
    beyond: {
      kicker: "Beyond development",
      title: "Beyond the code",
      sub: "Building apps is only part of it: I write poems and prose, I debunk hoaxes, I perform magic and I teach learning techniques. The rest lives on my blog, La Sveglia e il Risveglio.",
      articlesTitle: "Selected articles from the blog",
      history: "The blog came before the apps: since 2017 I've been publishing poems, haiku, prose and science communication. La Sveglia e il Risveglio is my personal space — the shouts when something makes me angry, the silence when I write in verse. The articles below are just a selection: on the blog you'll find the full archive, from 5G and conspiracy debunking to the more intimate pieces about friendship and life paths.",
      readArticle: "Read the article",
      blogCta: "Visit the blog",
    },
    music: {
      kicker: "Music",
      title: "My music",
      desc: "24 tracks I created with Suno: from the background music of Parole in Coda and Cifroo, designed for focus, to Lovecraftian atmospheres perfect for Cthulhu Tracker sessions.",
      songs: "24 tracks · Playlist by DottorFabio",
      nowPlaying: "Now playing",
      morePre: "Plus other tracks based on articles and poems from my ",
      moreLink: "blog",
      morePost: ".",
      cta: "Listen on Suno",
    },
    youtube: {
      kicker: "YouTube",
      title: "Latest videos",
      more: "Visit the channel",
    },
    social: {
      kicker: "Social",
      title: "Follow me around",
      twitch: "Follow on Twitch",
      youtube: "Subscribe on YouTube",
      instagram: "Follow on Instagram",
    },
    footer: {
      apps: "Apps",
      legal: "Legal",
      contact: "Contact",
      donate: "Donate with PayPal",
      rights: "© 2026 Fabio Comelli — All rights reserved",
    },
    privacy: {
      updated: "Last updated",
      back: "Back to home",
      forApp: "Privacy Policy for",
      switchNote: "Leggi in italiano",
      indexTitle: "Privacy Policy",
      indexH1: "App and site privacy policies",
      indexSub: "All the privacy policies for the apps and the site, gathered in a single page.",
    },
  },
};
